import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import HomePremium from "./pages/Home";
import AboutPremium from "./pages/About";
import ContactPremium from "./pages/Contact";
import ApplyPremium from "./pages/Apply";
import AuditionsPremium from "./pages/Auditions";
import PrivacyPolicyPremium from "./pages/PrivacyPolicy";
import RequestToMinorsPremium from "./pages/RequestToMinors";
import FAQPremium from "./pages/FAQ";
import DerivativeWorksPremium from "./pages/DerivativeWorks";
import NotFoundPremium from "./pages/NotFound";
import NavbarPremium from "./components/layout/Navbar";
import FooterPremium from "./components/layout/Footer";
import ScrollToTop from "./components/common/ScrollToTop";

const App = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Livneu VTuber Agency",
    description:
      "Sri Lanka's first professional VTuber agency under LEVELSTAIR - Empowering the next generation of virtual stars through professional management and cutting-edge technology",
    url: "https://livneu.levelstair.com",
    foundingDate: "2025",
    areaServed: {
      "@type": "Country",
      name: "Global",
    },
    audience: {
      "@type": "Audience",
      audienceType:
        "VTuber Talent, Content Creators, Virtual Entertainment Enthusiasts, Digital Artists, Anime Community",
    },
    knowsAbout: [
      "Professional VTuber Management",
      "Virtual Talent Development",
      "Premium Avatar Design",
      "Live2D Animation",
      "3D Character Modeling",
      "Streaming Growth Strategies",
      "Virtual Entertainment Production",
      "Digital Performance Technology",
      "Virtual Events Management",
      "Brand Partnership Development",
      "Merchandising Strategy",
      "Global Audience Development",
    ],
    slogan: "The Digital Stardom of LK",
  };

  return (
    <HelmetProvider>
      <div className="min-h-screen smooth-transition relative">
        <Helmet>
          <meta
            name="application-name"
            content="Livneu VTuber Agency"
          />
          <meta name="theme-color" content="#C8A2FF" />
          <meta name="msapplication-TileColor" content="#C8A2FF" />
          <meta
            name="description"
            content="Livneu - Empowering the Next Generation of Virtual Stars. Sri Lanka's premier VTuber agency under LEVELSTAIR, crafting digital personalities for global audiences."
          />
          <meta
            name="keywords"
            content="VTuber Agency, Virtual Talent Management, Livneu, LEVELSTAIR, Virtual Entertainment, Live2D Animation, 3D Modeling, Professional VTuber, Virtual Streaming, Digital Entertainment, Sri Lanka VTuber"
          />
          <link rel="canonical" href="https://livneu.levelstair.com" />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
          />
        </Helmet>

        <Router>
          <ScrollToTop />
          <NavbarPremium />
          <Routes>
            <Route path="/" element={<HomePremium />} />
            <Route path="/about" element={<AboutPremium />} />
            <Route path="/apply" element={<ApplyPremium />} />
            <Route path="/auditions" element={<AuditionsPremium />} />
            <Route path="/contact" element={<ContactPremium />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPremium />} />
            <Route path="/request-to-minors" element={<RequestToMinorsPremium />} />
            <Route path="/faq" element={<FAQPremium />} />
            <Route path="/derivative-works" element={<DerivativeWorksPremium />} />
            <Route path="*" element={<NotFoundPremium />} />
          </Routes>
          <FooterPremium />
        </Router>
      </div>
    </HelmetProvider>
  );
};

export default App;
